export default "__VITE_ASSET__98a4c556__"